const PAYMENT_MODES = [
  'openbanking_session',
  'openbanking_sessionless',
  'se_connected_account',
] as const;

export type PaymentMode = (typeof PAYMENT_MODES)[number];

export function isPaymentMode(s: unknown): s is PaymentMode {
  return PAYMENT_MODES.includes(s as PaymentMode);
}
